'use strict'
const permission = {
    path: 'export',
    name:'export',
	meta: {
        title: '我的导出-秀川结算中心-综合服务平台',
        name:'',
        tagsTitle: '我的导出',
        code: 'exports.index'
    },
    redirect:{
        name:'export-router'
    },
    component: () => import('@/components/RouterViewTab'),
    children:[
        {
            path: '',
            name: 'export-router',
            meta: {
                title: '我的导出-秀川结算中心-综合服务平台',
                name: '',
                tagsTitle: '我的导出',
                code: 'exports.index'
            },
            redirect: {
                name: 'export-list'
            },
            component: () => import('@/components/RouterView'),
            children:[
                {
                    path: '',
                    name: 'export-list',
                    meta: {
                        title: '我的导出-秀川结算中心-综合服务平台',
                        name: '我的导出',
                        tagsTitle: '我的导出',
                        code: 'exports.index'
                    },
                    component: () => import('@/pages/export/Export'),
                }
            ]
        }

    ]
	
};


export default permission;